'use strict';

import { SchemaManager, RedocComponent, BaseComponent } from '../base';
import { OptionsService } from '../../services/index';

@RedocComponent({
  selector: 'api-info',
  styles: [`
    .api-info-header{font-weight:normal}:host>div{width:60%}a.openapi-button{padding:3px 8px 4px 8px;color:#0033a0;border:1px solid #0033a0;margin-left:0.5em;font-weight:normal}
  `],
  template: `
    <div>
      <h1 class="api-info-header">{{data.title}} ({{data.version}})</h1>
      <p *ngIf="data.description" innerHtml="{{data.description | marked}}"> </p>
      <p>
        <!-- TODO: create separate components for contact and license ? -->
        <span *ngIf="data.contact"> Contact:
          <a *ngIf="data.contact.url" href="{{data.contact.url}}">
            {{data.contact.name || data.contact.url}}</a>
          <a *ngIf="data.contact.email" href="mailto:{{data.contact.email}}">
            {{data.contact.email}}</a>
        </span>
        <span *ngIf="data.license"> License:
          <a *ngIf="data.license.url" href="{{data.license.url}}"> {{data.license.name}} </a>
          <span *ngIf="!data.license.url"> {{data.license.name}} </span>
        </span>
      </p>
      <p>
        Download OpenAPI (fka Swagger) specification:
        <a class="openapi-button" target="_blank" attr.href='{{specUrl}}'> Download </a>
      </p>
    </div>
  `
})
@Reflect.metadata('parameters', [[SchemaManager], [OptionsService]])
export class ApiInfo extends BaseComponent {
  constructor(schemaMgr, optionsService) {
    super(schemaMgr);
    this.optionsService = optionsService;
  }

  prepareModel() {
    this.data = this.componentSchema.info;
    this.specUrl = this.optionsService.options.specUrl;
  }
}
